<dashboard-filters [widgetData]="config.data" (filterChanged)="handleFilterUpdate($event)"></dashboard-filters>


@if (!config.loaded) {
  <div class="loader-overlay"
    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.9); z-index: 10; display: flex; align-items: center; justify-content: center;">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
}

<div id="my-superset-container" style="width: 100%; height: 100%;"></div>

